<template>
  <div class="about">
    <div class="about__header">
      <div class="about__header__title">
        <span class="subhead meet">Meet ADX</span>
        <h3 class="xlarge-title title">Now Advertising</h3>
        <h3 class="xlarge-title title">Has Never Been This Easy</h3>
        <span class="subhead description">Now Advertising become easier, more effective, and much more affordable than ever before. It all starts from Rp 10.000</span>
      </div>
      <div class="about__header__play" @click.stop="toggleModal">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 20">
          <path fill="#FFF" fill-rule="evenodd" d="M1.834 19.133a.98.98 0 0 1-1.01-.95V1.593a.981.981 0 0 1 1.01-.948l16.427 8.533a.945.945 0 0 1 0 1.423c-.756.71-16.427 8.533-16.427 8.533z"/>
      </svg>
      </div>
    </div>
    <div class="about__overview">
      <div class="intro">
        <h1 class="small-title title">Company Overview</h1>
        <p class="description">ADX Asia delivers your messages in an instant through our physical network of digital screens accross cities. We build proprietary technology to cater our revolutionary business model as an advertising spot platform. We are young company with grand mission that moves in extraordinary speed. One year since its inception, we are now operating in four Indonesian biggest cities, aiming to have 1000 screens by the end of its second year.</p>
      </div>
      <div class="stage">
        <div class="value">
          <h2 class="small-title title">OUR VALUE</h2>
          <p class="description">We believe that company value is an extension of its founder's personality. We are fair, transparent, and honest. We strive to bring values to as many people as possible from our business practice. It is in our DNA to build a better tommorrow</p>
        </div>
        <div class="mission">
          <h2 class="small-title title">OUR MISSION</h2>
          <p class="description">We want to make our tagline a reality: Ads for everyone. We are leverage technological advancement to level the playing field in advertising industry. All this time, many of advertising channels are only accessible by big corporations. We are determined to make those affordable for literrally everyone</p>
        </div>
      </div>
    </div>
    <div class="about__wedo">
      <div class="about__wedo__wrapper">
        <div class="about__wedo__wrapper__image">
          <slick
            ref="slick"
            :options="slickOptions">
              <div class="image-container">
                <img class="image" src="/img/about/easy.jpg" alt="">
                <h4 class="title">Easy</h4>
                <p class="description">Starting campaigns in minutes, not weeks, not days.</p>
              </div>
              <div class="image-container">
                <img class="image" src="/img/about/affordable.jpg" alt="">
                <h4 class="title">Affordable</h4>
                <p class="description">Price starts from Rp 11.000 instead of hundreds of millions.</p>
              </div>
              <div class="image-container">
                <img class="image" src="/img/about/wide.jpg" alt="">
                <h4 class="title">Wide Selection</h4>
                <p class="description">More than 400 channels in Indonesia to help you succeed in your marketing goal.</p>
              </div>
          </slick>
        </div>
        <div class="about__wedo__wrapper__description">
          <h1 class="small-title title">What We Can Do for Advertisers?</h1>
          <p class="description-1">Advertising through digital screens accross the cities has never been easier. Traditionally, you need to call agencies, make price inquiry, send content, and they will manually insert USBs behind the screen to play your content. With such manual approach, overhead cost skyrockets. This makes the whole ordeal long, cumbersome, stresful, and expensive.</p>
          <p class="description-2">
          We develop a proprietary technology to streamline the whole process and deliver amazing experience. Through our website, reaching hundreds of thousands of people is only a fingertip away. Thanks to our cutting edge technology, you can even book one screen for one day (minimum of 80 playbacks), starting from Rp10.000.</p>
        </div>
      </div>
    </div>
    <div class="about__host">
      <div class="about__host__wrapper">
        <div class="about__host__wrapper__description">
          <div class="about__host__wrapper__description--one">
            <h1 class="small-title title">What We Can Do for Hosts?</h1>
            <p class="description-1">If your business drives traffic, you are in for additional revenue. In this age of information, everyone is racing to convey messages to relevant groups of people. We help you set up digital screens necessary to turn the demand into revenue. Companies and business are willing to pay you to deliver their messages to your audience</p>
            <p class="description-2">
            We provide tools and tehcnology so you can just sit back and relax. No Risk, no initial investment, no effort required. We got you covered.</p>
          </div>
          <div class="about__host__wrapper__description--two">
            <div class="stage">
              <h2 class="small-title title">NEW REVENUE SOURCE</h2>
              <p class="description">Monetize your traffic directly to advertisers. With digitalized inventory, you can sell billions of potential advertising revenue with only one person managing it. Direct selling also helps you get more revenue compared to selling to agencies.</p>
            </div>
            <div class="stage">
              <h2 class="small-title title">ZERO INVESTMENT ZERO EFFORT</h2>
              <p class="description">Sit back and relax. No initial investment required. No need to find advertisers. As a platform, it is in our best interest to make advertisers come on board with us. We got your back</p>
            </div>
          </div>
        </div>
        <div class="about__host__wrapper__image">
          <img class="image" src="/img/about/BG.jpg" alt="">
        </div>
      </div>
    </div>
    <div class="about__founder">
      <div class="about__founder__wrapper">
        <h1 class="small-title about__founder__wrapper__title">Founder’s Profile</h1>
        <div class="about__founder__wrapper__profile">
          <div class="about__founder__wrapper__profile--img">
            <img class="img-circle" src="/img/founder/elbert.png" alt="">
          </div>
          <div class="about__founder__wrapper__profile--description">
            <h2 class="name">ELBERT TOHA</h2>
            <p class="position">CEO & CTO</p>
            <p class="description-1">Elbert is the technical founder and CEO of ADX Asia. He completed his bachelor degree in Universitas Indonesia in 2011. He then went on to take master degree in Technopreneurship and Innovation in Nanyang Technology University (NTU) Singapore in 2015.</p>
            <p class="description-2">He started his career in the most prestigious consulting firm in the world, McKinsey & Company. He undergone several studies spanning broad range of topics such as market entry, consumer research, and corporate governance. Growing up in entrepreneurial family, He is aspired to be one since childhood. This aspiration drove him to quit his well-paid job and started an exciting entrepreneurial journey. Through his deep passion in business, technology, and years of crystalized knowledge, ADX Asia is born.</p>
          </div>
        </div>
        <div class="about__founder__wrapper__profile">
          <div class="about__founder__wrapper__profile--img">
            <img class="img-circle" src="/img/founder/eko.png" alt="">
          </div>
          <div class="about__founder__wrapper__profile--description">
            <h2 class="name">EKO PAULUS</h2>
            <p class="position">CMO & COO</p>
            <p class="description-1">Eko is growth hacker of ADX Asia. Graduated with civil engineering degree from Universitas Parahyangan, he joined Nutrifood, a well-respected Fast Moving Consumer Good(FMCG) company. His passion in leadership together with his talent put him in sales function, the lifeblood of every FMCG company.</p>
            <p class="description-2">His marketing and sales brilliance catapulted him into youngest regional manager within 3 years, less than half of the normal time. His last position was National Hotels, Restaurants, and Cafes (Horeca) manager, bringing products such as L-Men and Tropicana Slim to these channels. His network in the aforementioned channels is well-established with good long-standing relationship with owners. He loves challanges and always go where others will not. He is calculated risk-taker who strive for excellence in all his work</p>
          </div>
        </div>
      </div>
    </div>
    <div class="about__trusted">
      <div class="about__trusted__wrapper">
        <h1 class="small-title title">We are trusted by Advertisers</h1>
        <!-- <p class="description">Numerous well-known brands have entrusted us to deliver messages to their target audience. The affordabillity and speed provide advertisers with most value, making us an exciting and excellent alternative media to reach customer base.</p> -->
        <div class="about__trusted__wrapper__image">
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/trusted/airasia.jpg" alt="" >
          </div>
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/trusted/viu.jpg" alt="" >
          </div>
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/trusted/POLYTRON.jpg" alt="" >
          </div>
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/trusted/pp_property.jpg" alt="" >
          </div>
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/trusted/oppo.jpg" alt="" >
          </div>
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/trusted/shoopee.jpg" alt="" >
          </div>
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/trusted/hp.jpg" alt="" >
          </div>
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/trusted/entrostop.jpg" alt="" >
          </div>
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/trusted/BJB.jpg" alt="" >
          </div>
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/trusted/blibli.jpg" alt="" >
          </div>
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/trusted/tokopedia.png" alt="" >
          </div>
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/trusted/TROPICANASLIM.jpg" alt="" >
          </div>
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/trusted/samsung.jpg" alt="" >
          </div>
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/trusted/bhineka.jpg" alt="" >
          </div>
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/trusted/SAFE_CARE.jpg" alt="" >
          </div>
        </div>
      </div>
    </div>
    <div class="about__trusted">
      <div class="about__trusted__wrapper">
        <h1 class="small-title title">We are trusted by Host</h1>
        <!-- <p class="description">Numerous well-known brands have entrusted us to deliver messages to their target audience. The affordabillity and speed provide advertisers with most value, making us an exciting and excellent alternative media to reach customer base.</p> -->
        <div class="about__trusted__wrapper__image">
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/host/angkasa_pura.jpg" alt="" >
          </div>
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/host/citilink_logo.jpg" alt="" >
          </div>
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/host/garuda_indonesia.jpg" alt="" >
          </div>
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/host/pertamina.jpg" alt="" >
          </div>
          <div class="about__trusted__wrapper__image__card">
            <img class="img-circle" src="/img/host/superindo.jpg" alt="" >
          </div>
        </div>
      </div>
    </div>
    <div class="about__location">
      <div class="about__location__wrapper">
        <h1 class="small-title title">Our Office</h1>
        <h2 class="description">HEADQUARTER</h2>
        <p class="description">Jalan Muara Karang </p>
        <p class="description">Blok D7 Barat No 45-46</p>
        <p class="description">Jakarta Utara - 14450 </p>
        <p class="description">Indonesia</p>
      </div>
    </div>
    <modal v-if="isOpen" @modal-close="toggleModal" :type="`large`">
      <div slot="content" class="content">
        <iframe width="100%" height="100%" src="https://www.youtube.com/embed/noVYVpLZykk?rel=0&autoplay=1&showinfo=0&controls=0" frameborder="0" allowfullscreen>
        </iframe>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import Slick from 'vue-slick'

export default {
  name: 'adx-aboutus',
  components: {
    'modal': Modal,
    'slick': Slick,
  },
  props: {

  },
  data() {
    return {
      isOpen: false,
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        nextArrow: '<button type="button" style="' +
                  'top:32%; width:32px; height:32px; position:absolute; right:-16px;"' +
                  'aria-disabled="false"><i class="icon-chevronright"></i></button>',
        prevArrow: '<button type="button" style="' +
                  'top:32%; width:32px; height:32px; position:absolute; left:-16px;"' +
                  'aria-disabled="false"><i class="icon-chevronleft"></i></button>',
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,

            }
          },
          {
            breakpoint: 1920,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,

            }
          }
        ]
      },
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    toggleModal() {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>